import { render, staticRenderFns } from "./ErrorBooklets.vue?vue&type=template&id=0010439c&"
import script from "./ErrorBooklets.vue?vue&type=script&lang=ts&"
export * from "./ErrorBooklets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports